import React, { useState, useEffect, useRef } from 'react';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { useData } from 'global/hooks/useData';
import { first, get, sortBy, set, take, startCase, size } from 'global/lib/lodash';
import { CenterContent, GridContainer } from 'global/components/perform-grid';
import { Link, Icon, Table, TableBody, TableRow, TableCell, Tooltip } from '@mui/material';
import withRouter from 'react-router-dom/withRouter';
import useStyles from './styles';
import { Column, Row } from 'global/components/row';
import { Text } from 'global/components/text';
import { CenterLoader, Loader, useScreen } from 'global/styles';
import clsx from 'clsx';
import { Button, IconButton } from 'global/components/Button';
import Form from 'global/components/form';
import moment from 'moment';
import { DocumentTypes, StatusTypes } from './editions';
import { _size, uppercaseFirst, cleanCopy } from 'global/utils';
import colors from 'global/styles/colors';
import sendData from 'redux/actions/sendData';
import SearchBar from 'global/components/SearchBar';
import DndTable from 'global/components/DragTable';
import { EdDocModal } from './eddocmodal';
import SnackAlerts from 'global/components/snack-alerts';
import { FullScreen } from 'global/components/modal';
import { CloneEdition } from './cloneedition';
import useDebounce from 'global/hooks/useDebounce';
import { AddEditionsList } from './addedtions';
import { TransferModal } from './transfermodal';
import ConfirmModal from 'global/components/confirm';
import { ButtonDrop } from '../../../global/components/Button';
import { CreateChecklist } from './create-checklist';
import { CreateSBS } from './create-sbs';
import { pluralize, realmsToString } from '../../../global/utils';
import { FileUpload } from '../../document/DocumentContainer/FileUpload';
import { CreateScorecard } from './create-scorecard';
import { UploadFiles } from '../../../redux/actions/imageUploader';
import { EditScorecard } from './edit-scorecard';
import { RoomAssignmentsModal } from './room-assignments';
import { RealmAssignmentsModal } from './realm-assignments';

export const EDITIONINCLUDES = [
  'images',
  'realm',
  'realms',
  'realms.parent',
  'scorecards',
  'scorecards.realms',
  'scorecards.userGroups',
  'origin',
  'progeny',
  'userGroups',
  'documents',
  'documents.document',
  'documents.document.classification',
  'documents.document.classification.assembly',
  'documents.document.classification.material',
  'documents.document.classification.material.parent',
  'documents.document.classification.system',
  'checklists',
  'scopeOfWorks',
  'stepBySteps',
  'primaryDocuments',
  'primaryDocuments.document',
  'checklists.checkpoints.checkpointOptions',
  'checklists.classification',
  'checklists.classification.assembly',
  'checklists.classification.material',
  'checklists.classification.material.parent',
  'checklists.classification.system',
]

export const ManageEdition = withRouter((props) => {
  const { isMobile } = useScreen();
  const edId = get(props, 'match.params.id', 0);
  const classes = useStyles();
  const { destroyCache } = useData();
  const [state, setState] = useState({
    isEdit: false,
    isEditList: false,
    isEditSc: false,
    isEditScList: false,
    formLoading: false,
    search: '',
    items: [],
    edDocs: undefined,
    newOptions: [
      { title: 'Checklist', id: 'checklist', Component: CreateChecklist },
      { title: 'Step By Step', id: 'stepbystep', Component: CreateSBS },
      { title: 'Video', id: 'video', Component: (p) => <FileUpload {...p} update={() => p.onClose(true)} doc={[]} showClass userCanEdit={true} fileType="video" /> },
      { title: 'Files', id: 'file', Component: (p) => <FileUpload {...p} update={() => p.onClose(true)} doc={[]} showClass userCanEdit={true} fileType="file" /> },
    ],
  });
  const [formState, setFormState] = useState({});
  const [transferProps, setTransferProps] = useState({
    open: false,
    title: 'TRANSFER OWNERSHIP',
    onClose: (updated = false) => {
      setTransferProps((s) => ({ ...s, open: false }));
      if (updated) {
        props.history.goBack();
      }
    },
  });
  const [basicModal, setBasicModal] = useState({
    open: false,
    onClose: () => {
      setBasicModal((s) => ({ ...s, title: null }));
    },
  });
  const [rms, setRms] = useState({
    modalProps: {
      open: false,
      onClose: () => {
        setRms(s => ({ ...s, modalProps: { ...s.modalProps, open: false } }))
      }
    }
  })
  const [locations, setLocations] = useState({
    modalProps: {
      open: false,
      onClose: () => {
        setLocations(s => ({ ...s, modalProps: { ...s.modalProps, open: false } }));
        update();
      }
    }
  })
  const formRef = useRef();

  const [alerts, setAlerts] = useState();

  const ugroups = useRetrieveData({ url: '/user-groups' }, { build: ['userGroups'] });
  const { data, loading, update } = useRetrieveData(
    { url: `/editions/${edId}` },
    {
      build: ['editions'],
      transformData: (d) => {
        return d.find((dd) => dd.id == edId);
      },
      params: {
        'scorecards[withInactive]': 1,
        include: EDITIONINCLUDES.join(','),
      },
    }
  );

  const edDocs = useRetrieveData(
    { url: `/edition-documents` },
    {
      build: ['editionDocuments'],
      params: {
        filter: {
          edition_id: edId,
        },
        include: 'classification,document,superset',
      },
    }
  );

  const isCourseType = get(data, 'editionType') === 'course';

  useEffect(() => {
    if (data.id && size(edDocs.data)) {
      let edocs;

      if (isCourseType) {
        edocs = sortBy(edDocs.data, 'order');
      } else {
        const classes = {};

        edDocs.data.map((ed) => {
          const { classificationId } = ed;

          set(ed, 'document.classification', ed.classification);

          set(classes, classificationId, sortBy([...get(classes, classificationId, []), ed], 'order'));
        });

        edocs = sortBy(
          Object.keys(classes).map((cl) => ({ ...first(classes[cl]), children: classes[cl] })),
          'order'
        );
      }

      setState((s) => ({ ...s, edDocs: edocs }));
    }
  }, [edDocs.data, data]);

  const [edDocModal, setEdDocModal] = useState({
    title: '',
    open: false,
    onClose: (updated = false) => {
      setEdDocModal((s) => ({ ...s, open: false }));
      if (updated) {
        edDocs.update();
      }
    },
  });

  const [cloneProps, setCloneProps] = useState({
    open: false,
    onClose: (updated) => {
      setCloneProps((s) => ({ ...s, open: false }));
      if (updated) {
        update();
        edDocs.update();
      }
    },
  });

  const [addProps, setAddProps] = useState({
    open: false,
    addDocs: async (edocs) => {
      await sendData({
        url: `/editions/${edId}`,
        method: 'patch',
        data: {
          data: {
            type: 'editions',
            id: edId,
            relationships: {
              attachDocuments: {
                data: edocs.map((ed) => ({ type: 'edition-documents', id: get(ed, 'id') })),
              },
            },
          },
        },
      });
    },
    onClose: (updated) => {
      setAddProps((s) => ({ ...s, open: false }));
      if (updated) {
        update();
        edDocs.update();
      }
    },
  });

  const [createProps, setCreateProps] = useState({
    open: false,
    onClose: (updated) => {
      setCreateProps((s) => ({ ...s, centerContentStyle: {}, open: false }));
      if (updated) {
        update();
        edDocs.update();
      }
    },
  });

  const debSearch = useDebounce(state.search, 700);

  useEffect(() => {
    if (!!debSearch) {
      const st = debSearch.toLowerCase();
      const docs = cleanCopy(edDocs.data).filter((d) => {
        const sels = ['document.name'];

        if (d.children) {
          d.children = d.children.filter((dc) => {
            let found;

            if (sels.find((s) => get(d, s, '').toLowerCase().indexOf(st) > -1)) {
              found = true;
            }

            return found;
          });
        }

        return !!_size(d.children);
      });
      setState((s) => ({ ...s, edDocs: docs }));
    } else {
      setState((s) => ({ ...s, edDocs: undefined }));
    }
  }, [debSearch]);

  useEffect(() => {
    destroyCache('edition-documents?');
  }, []);

  const onSave = async () => {
    try {
      setState((s) => ({ ...s, formLoading: true, isEdit: false }));

      const realms = get(formState, 'realms') ? (Array.isArray(formState.realms) ? formState.realms : Object.keys(formState.realms)).map(k => ({ type: 'realms', id: k.id || k })) : undefined;
      const userGroups = get(formState, 'userGroups') ? formState.userGroups.map(id => ({ type: 'user-groups', id })) : undefined;
      
      const d = {
        data: {
          id: edId,
          type: 'editions',
          attributes: {
            images: formState.images,
            name: get(formState, 'name'),
            edition_type: get(formState, 'edition_type'),
            status: get(formState, 'status'),
          },
          relationships: {
            realms: realms ? { data: realms } : undefined,
            userGroups: userGroups ? { data: userGroups } : undefined,
          }
        },
      };

      await UploadFiles(d);

      await sendData({
        url: `/editions/${edId}`,
        method: 'patch',
        data: d,
      });

      const sortedOriginalRealms = sortBy(data.realms, 'id');
      const sortedNewRealms = sortBy(realms, 'id')
      if (sortedOriginalRealms.map(r => r.id).join(',') != sortedNewRealms.map(r => r.id).join(',')) {
        await Promise.all(data.scorecards.map(async sc => {
          await sendData({
            url: `/scorecards/${sc.id}`,
            method: 'patch',
            data: {
              data: {
                id: sc.id,
                type: 'scorecards',
                relationships: {
                  realms: { data: sortedNewRealms }
                }
              }
            }
          })
        }))
      }

      update();
    } catch (err) {
      alert(err);
    } finally {
      setState((s) => ({ ...s, formLoading: false }));
    }
  };

  const onSaveOrder = async () => {
    try {
      await Promise.all(
        state.items.map((doc, i) => {
          return sendData({
            url: `/edition-documents/${doc.id}`,
            method: 'patch',
            data: {
              data: {
                id: doc.id,
                type: 'edition-documents',
                attributes: {
                  order: i.toString(),
                },
              },
            },
          });
        })
      );
      setState((s) => ({ ...s, isEditList: false }));
      edDocs.update();
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    }
  };

  const setupEdDocModal = (row) => {
    setEdDocModal((s) => ({
      ...s,
      title: row ? 'EDIT EDITION DOCUMENT RELATIONSHIP' : 'CREATE NEW EDITION DOCUMENT',
      open: true,
      isCourseType,
      doc: row,
    }));
  };

  const getDocument = async (row) => {
    let result;

    if (row.documentableType === 'checklist') {
      result = await sendData(
        {
          url: `/checklists/${row.documentableId}`,
        },
        {
          params: {
            include: 'checkpoints.checkpointOptions',
          },
          normalize: { build: [pluralize(row.documentableType)] },
        }
      );
    } else {
      result = await sendData(
        {
          url: `/step-by-steps/${row.documentableId}`,
        },
        {
          params: {
            include: 'items,items.images',
          },
          normalize: { build: ['stepBySteps'] },
        }
      );
    }
  };

  const deleteSubmit = () => {
    setBasicModal((s) => ({
      ...s,
      title: 'Delete Edition',
      content: 'Are you sure you want to delete this edition?',
      onOk: async () => {
        await sendData(
          {
            url: `/editions/${edId}`,
            method: 'patch',
            data: {
              data: {
                type: 'editions',
                id: edId,
                attributes: {
                  archived: true,
                },
              },
            },
          },
          { simulate: false }
        );
        s.onClose();
        props.history.push('/account/content');
      },
      onCancel: () => {
        s.onClose();
      },
    }));
  };

  const deleteEdDoc = (row) => {
    setBasicModal((s) => ({
      ...s,
      title: 'Delete Document',
      content: 'Are you sure you want to delete this document?',
      onOk: async () => {
        await sendData(
          {
            url: `/edition-documents/${row.id}`,
            method: 'delete',
          },
          { simulate: false }
        );
        edDocs.update();
        s.onClose();
      },
      onCancel: () => {
        s.onClose();
      },
    }));
  };

  const renderRow = (row) => {
    const colspan = _size(COLUMNS);
    const style = { padding: 0, paddingBottom: 16 };

    const metaoptions = [
      { title: 'Duration', key: 'meta.duration' },
      { title: 'Random Options', key: 'meta.random' },
      { title: 'Random Checkpoints', key: 'meta.randomcheck' },
      { title: 'Type', key: 'meta.type' },
      { title: 'Question Count', key: 'meta.questcount' },
      { title: 'Passing Score', key: 'meta.pass' },
    ];

    return (
      <TableCell style={style} scope="row" colSpan={colspan} onClick={() => getDocument(row)}>
        <Table>
          <TableBody>
            <TableRow className="noBorder">
              <TableCell colSpan={colspan}>
                <Row fullWidth>
                  {state.isEditList && <Icon>drag_indicator</Icon>}
                  <Text style={{ paddingLeft: 8 }}>{get(row, 'document.name')}</Text>
                  <Text italic>{`: ${get(row, 'document.classification.name', get(row, 'classification.name'))}`}</Text>
                </Row>
              </TableCell>
            </TableRow>
            {get(row, 'children', [row]).map((item, i) => {
              const metaopts = metaoptions.filter((m) => get(item, m.key) !== undefined);

              return (
                <>
                  <TableRow className={'noBorder'}>
                    {COLUMNS.map((col) => {
                      const val = col.render ? col.render(item, get(item, col.field), i) : get(item, col.field);
                      return (
                        <TableCell key={col.field} width={col.width} style={{ paddingBottom: 0 }}>
                          {val}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                  <TableRow className="noBorder">
                    <TableCell colSpan={colspan} style={{ padding: 0 }}>
                      <Row style={{ marginLeft: 64 }}>
                        {metaopts.map((m) => {
                          const val = get(item, m.key);
                          return <Text italic type="label_small" style={{ marginRight: 8 }}>{`${m.title}: ${uppercaseFirst(val)}`}</Text>;
                        })}
                      </Row>
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableCell>
    );
  };

  const cloneItem = () => {
    setCloneProps((s) => ({
      ...s,
      title: `Clone ${get(data, 'name')}`,
      open: true,
    }));
  };

  const addExisting = () => {
    const title = (() => {
      let text = `Adding Documents to "${get(data, 'name')}"`;
      const amt = isMobile ? 46 : Infinity;
      if (_size(text) >= amt) {
        text = take(text, amt).join('') + '...';
      }
      return text;
    })();
    setAddProps((s) => ({
      ...s,
      centerContentStyle: { padding: 0, position: 'relative', bottom: 0, marginBottom: isMobile ? undefined : 60, top: 0 },
      title,
      open: true,
    }));
  };

  const transferItem = () => {
    setTransferProps((s) => ({
      ...s,
      open: true,
    }));
  };

  const onSelectNew = (opt) => {
    setCreateProps((s) => ({
      ...s,
      open: true,
      Component: opt.Component,
      title: `Create ${opt.title}`,
    }));
  };

  const onSelectNewSc = (opt) => {
    setCreateProps((s) => ({
      ...s,
      open: true,
      edition: data,
      Component: CreateScorecard,
      centerContentStyle: { padding: 0 },
      title: `Create New Scorecard`,
      onClose: (updated, card) => {
        setCreateProps((s) => ({ 
          ...s, 
          centerContentStyle: {}, 
          open: false,
          onClose: (updated) => {
            setCreateProps((s) => ({ ...s, centerContentStyle: {}, open: false }));
            if (updated) { update(); edDocs.update();}
          },
        }));

        if (updated) {
          update();
          edDocs.update();

          setAlerts({ message: `${get(card, 'name', '')} has been created!`, messageProps: { anchorOrigin: { vertical: 'top', horizontal: 'center' } } });

          const canShowEditRoomAssigments = (() => {
            const tiers = get(card, 'config.allowedTiers');
            return !size(tiers) || tiers.includes('lot') ? true : false;
          })();

          if (canShowEditRoomAssigments) {
            setRms(s => ({
              ...s,
              subtitleAdd: 'Your Scorecard has already been saved, closing this form will not impact it. ',
              scorecard: card,
              modalProps: {
                ...s.modalProps,
                open: true,
                title: `Edit Room Assigments for ${get(card, 'name')}`,
              }
            }))
          }
        }
      },
    }));
  };

  const delScorecard = sc => {
    setBasicModal((s) => ({
      ...s,
      title: 'Delete Scorecard',
      content: `Are you sure you want to delete "${sc.name}"?`,
      onOk: async () => {
        await sendData(
          {
            url: `/scorecards/${sc.id}`,
            method: 'patch',
            data: {
              data: {
                type: 'scorecards',
                id: sc.id,
                attributes: {
                  archived: true,
                },
              },
            },
          },
        );
        s.onClose();
        update();
        setState(s => ({ ...s, isEditScList: false }));
      },
      onCancel: () => {
        s.onClose();
      },
    }));
  }

  const editScorecard = sc => {
    setCreateProps((s) => ({
      ...s,
      edition: data,
      open: true,
      scorecard: sc,
      userGroups: ugroups.data,
      Component: EditScorecard,
      centerContentStyle: { padding: 0 },
      title: `Edit Scorecard`,
    }));
  }

  const renderScRow = sc => {
    const delDisabled = sc.hasAssessments;
    const _rows = [
      { key: 'name', render: r => r },
      { key: 'realms', render: r => realmsToString(r) },
      { key: 'userGroups', render: r => r.map(r => r.name).join(', ') },
    ]
    return (
      <Row>
        {state.isEditScList && <IconButton onClick={() => editScorecard(sc)} icon="edit" color="secondary" size="small" />}
          {_rows.map(r => {
            return <div style={{ width: `${100 / size(_rows)}%` }}><Text type="label_medium">{r.render(get(sc, r.key, []))}</Text></div>
          })}
        {state.isEditScList && <IconButton icon="delete" disabled={delDisabled} onClick={() => delScorecard(sc)} toolTip={delDisabled && "This scorecard has assessment data associated with it and can’t be deleted"} size="small" />}
      </Row>
    )
  }

  const toggleEdit = () => {
    setState((s) => ({ ...s, isEdit: !s.isEdit }))
    if (state.isEdit) {
      get(formRef, 'current.clearState', () => 0)();
    }
  }

  const setupEditLocations = () => {
    setLocations(s => ({ 
      ...s, 
      editionId: edId, 
      modalProps: { 
        ...s.modalProps, 
        open: true,
        title: `Edit Location Assigments for ${get(data, 'name')}`,
      } 
    }));
  }

  const COLUMNS = [
    {
      field: 'blank',
      title: '',
      width: 10,
      render: (row) => {
        return state.isEditList ? (
          <IconButton color="secondary" onClick={() => setupEdDocModal(row)} size="small">
            <Icon>edit</Icon>
          </IconButton>
        ) : null;
      },
    },
    {
      field: 'document.name',
      title: 'Title',
      width: 200,
    },
    {
      field: 'documentableType',
      title: 'Type',
      width: 200,
      render: (row, text) => {
        return startCase(text.split('_').join(' '));
      },
    },
    {
      field: 'meta.realms',
      title: 'Locations',
      width: 200,
      render: (row) => {
        const rms = get(data, `config.docs.${row.id}.realms`, []);
        return size(rms) ? realmsToString(rms) : 'Any';
      },
    },
    {
      field: 'shared',
      title: 'Shared',
      width: 100,
      render: (row, text) => {
        return !!row.shared ? 'Shared' : 'Unique';
      },
    },
    !isCourseType && {
      field: 'primary',
      title: 'Primary',
      width: 90,
      render: (row, text, index) => {
        return !!row.primaryDocument ? 'Yes' : 'No';
      },
    },
    isCourseType && {
      field: 'superset.name',
      title: 'Superset',
      width: 90,
    },
    {
      field: 'blank2',
      title: '',
      width: 10,
      render: (row) => {
        return state.isEditList ? (
          <IconButton color="secondary" onClick={() => deleteEdDoc(row)} size="small">
            <Icon>delete</Icon>
          </IconButton>
        ) : null;
      },
    },
  ].filter((f) => !!f);

  const canDelete = get(data, 'id') == get(data, 'latestId') || get(data, 'latestId') == null;

  const editionDocs = get(state, 'edDocs', edDocs.data);

  return (
    <GridContainer>
      <CenterContent fullWidth>
        <div className={clsx(classes.container, classes.manage)}>
          <Link onClick={() => props.history.push('/account/content')}>
            <Row>
              <Icon>arrow_back</Icon>back to Edition list
            </Row>
          </Link>

          {loading && <CenterLoader />}

          {!loading && (
            <div className="mainContainer">
              <Row>
                <Text type="headline_large">{get(data, 'name', '')}</Text>
                <Text type="secondarySub" italic style={{ marginLeft: 'auto' }}>{`Created: ${moment(get(data, 'createdAt')).format('ll')}`}</Text>
              </Row>

              <Column>
                <Row className="buttonRow">
                  <Button disabled={!!state.isEdit} onClick={cloneItem} startIcon={<Icon>add</Icon>}>
                    CLONE
                  </Button>
                  <Button disabled={!!state.isEdit} onClick={transferItem} startIcon={<Icon>play_circle_outline</Icon>}>
                    TRANSFER OWNERSHIP
                  </Button>
                </Row>
                <Row className="buttonRow">
                  <Button onClick={toggleEdit} startIcon={<Icon>{state.isEdit ? 'close' : 'edit'}</Icon>}>
                    {state.isEdit ? 'CANCEL' : `EDIT`}
                  </Button>
                  {!!state.isEdit && (
                    <Tooltip
                      title={
                        !canDelete
                          ? "You cannot delete this edition because it's not the latest in it's lineage; there is child data derived from it. If you would like to remove it, delete all it's children first."
                          : 'Delete Edition'
                      }
                    >
                      <span>
                        <Button disabled={!canDelete} bgColor={colors.danger} onClick={deleteSubmit} startIcon={<Icon>{'delete'}</Icon>}>{`DELETE`}</Button>
                      </span>
                    </Tooltip>
                  )}
                </Row>
              </Column>

              <Form
                ref={formRef}
                showAllScreens
                formLoading={state.formLoading}
                onFormState={setFormState}
                canSubmit={state.isEdit}
                submitText="SAVE"
                submitIcon={<Icon>save</Icon>}
                onSubmit={onSave}
                formStyle={classes.formStyle}
                screens={[
                  {
                    inputs: [
                      {
                        id: 'name',
                        type: 'TextField',
                        defaultValue: () => get(data, 'name', ''),
                        props: {
                          label: 'Title',
                          disabled: !state.isEdit,
                        },
                      },
                      {
                        id: 'edition_type',
                        type: 'Select',
                        data: DocumentTypes,
                        defaultValue: () => get(data, 'editionType', ''),
                        props: {
                          label: 'Type',
                          disabled: !state.isEdit,
                        },
                      },
                      {
                        id: 'status',
                        type: 'Select',
                        data: StatusTypes,
                        defaultValue: () => get(data, 'status', ''),
                        props: {
                          label: 'Status',
                          disabled: !state.isEdit,
                        },
                      },
                      get(data, 'editionType') === 'course' && {
                        id: 'images',
                        type: 'DropArea',
                        defaultValue: () => get(data, 'images', []),
                        required: true,
                        props: {
                          label: 'Cover Image',
                          disabled: !state.isEdit,
                          multiple: false,
                          showCaption: false,
                        },
                      },
                      {
                        id: 'status',
                        type: 'Select',
                        data: StatusTypes,
                        defaultValue: () => get(data, 'status', ''),
                        props: {
                          label: 'Status',
                          disabled: !state.isEdit,
                        },
                      },
                      {
                        id: 'realms',
                        type: 'DropRealms',
                        defaultValue: () => get(data, 'realms', {}),
                        props: {
                          label: 'Access',
                          onlyTiers: ['builder', 'division'],
                          hideNonUserBuilders: true,
                          disabled: !state.isEdit,
                        },
                      },
                      {
                        id: 'userGroups',
                        type: 'Select',
                        data: ugroups.data,
                        item: (item) => ({ value: item.id, title: item.name }),
                        defaultValue: () => get(data, 'userGroups', []).map(u => u.id),
                        props: {
                          multiple: true,
                          label: 'User Groups',
                          disabled: !state.isEdit,
                        },
                      },
                    ].filter(f => !!f),
                  },
                  {
                    inputs: [
                      {
                        id: 'parent',
                        type: 'TextField',
                        defaultValue: () => get(data, 'origin.name', ''),
                        props: {
                          label: 'Parent',
                          disabled: true,
                        },
                      },
                      {
                        id: 'children',
                        type: 'TextField',
                        defaultValue: () => (!_size(get(data, 'progeny')) ? 'None' : _size(get(data, 'progeny'))),
                        props: {
                          label: 'Children',
                          disabled: true,
                        },
                      },
                    ],
                  },
                ]}
              />

              {!state.isEdit && (
                <>
                  <Row>
                    <Text type="headline_large">{'Scorecards'}</Text>
                  </Row>

                  {/* TODO: Removed disabled characteristic when this feature is ready */}
                  <Row className="buttonRow">
                    <Button onClick={onSelectNewSc} startIcon={<Icon>add</Icon>}>
                      CREATE NEW
                    </Button>
                    <Button onClick={() => setState((s) => ({ ...s, isEditScList: !s.isEditScList }))} startIcon={<Icon>{state.isEditScList ? 'close' : 'edit'}</Icon>}>
                      {state.isEditScList ? 'CANCEL' : `EDIT LIST`}
                    </Button>
                  </Row>

                  <div className={classes.margBottom}>
                    <Text type="label_small">Scorecards</Text>
                    {get(data, 'scorecards', []).map(renderScRow)}
                  </div>
                </>
              )}

              {!state.isEdit && (
                <>
                  <Row>
                    <Text type="headline_large">{'Document List'}</Text>
                  </Row>

                  <Row className="buttonRow">
                    <Button disabled={state.isEditList} onClick={addExisting} startIcon={<Icon>add</Icon>}>
                      ADD EXISTING
                    </Button>
                    <ButtonDrop disabled={state.isEditList} onSelect={onSelectNew} options={state.newOptions} startIcon={<Icon>add</Icon>}>
                      CREATE NEW
                    </ButtonDrop>
                    <Button onClick={() => setState((s) => ({ ...s, isEditList: !s.isEditList }))} startIcon={<Icon>{state.isEditList ? 'close' : 'edit'}</Icon>}>
                      {state.isEditList ? 'CANCEL' : `EDIT LIST`}
                    </Button>
                    <Button onClick={setupEditLocations} startIcon={<Icon>{'home'}</Icon>}>
                      {`EDIT LOCATION ASSIGNMENTS`}
                    </Button>
                  </Row>

                  <SearchBar containerStyle={classes.searchBar} changeSearch={(t) => setState((s) => ({ ...s, search: t }))} />

                  <div className={classes.table}>
                    {edDocs.loading && (
                      <div className={clsx(classes.flexRow, classes.pad20)}>
                        <Loader />
                      </div>
                    )}
                    {!edDocs.loading && (
                      <DndTable columns={COLUMNS} canDrag={state.isEditList} onOrderChange={(items) => setState((s) => ({ ...s, items }))} items={editionDocs} renderRow={renderRow} />
                    )}

                    {state.isEditList && (
                      <Column style={{ padding: 8 }} center>
                        <Button onClick={() => onSaveOrder()} startIcon={<Icon>save</Icon>}>
                          SAVE
                        </Button>
                      </Column>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        <EdDocModal {...edDocModal} />
        <TransferModal {...transferProps} data={data} edId={edId} />
        <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
        <FullScreen {...cloneProps}>{!loading && <CloneEdition {...cloneProps} doc={{ ...data, editionDocuments: editionDocs }} />}</FullScreen>
        <FullScreen {...addProps}>{!!addProps.open && <AddEditionsList {...addProps} doc={{ ...data, editionDocuments: editionDocs }} />}</FullScreen>
        <FullScreen {...createProps}>
          {!!createProps.open && !!createProps.Component && <createProps.Component {...createProps} doc={{ ...data, editionDocuments: editionDocs }} editionId={edId} />}
        </FullScreen>
        <ConfirmModal {...basicModal} />
        <RoomAssignmentsModal {...rms} />
        <RealmAssignmentsModal {...locations} />
      </CenterContent>
    </GridContainer>
  );
});
